export default {
  title: "الدعم",
  payments: "لجميع الاستفسارات المتعلقة بالمدفوعات، يرجى التواصل عبر البريد الإلكتروني: {finance_email}.",
  spam: 'مهم: يرجى التحقق من مجلد "الرسائل غير المرغوب فيها" (Spam)!',
  other: "لجميع الاستفسارات الأخرى، يرجى استخدام النموذج أدناه.",
  faq: "الأسئلة الشائعة",
  faq_notice: "قبل إرسال طلبك، يرجى مراجعة قواعدنا وقسم {faq} (FAQ) — قد يكون الرد موجوداً هناك بالفعل.",
  response_time: "قد يستغرق الرد من 12 ساعة إلى يومين عملين، حسب تعقيد الطلب والعبء الحالي على فريق الدعم."
};
